import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import Api from '@/api'
import { IBaseStore } from '@/store/types'
import { IEligibilityTask, IEligibilityTaskFiltersDTO, IPatientLiability } from '@zunta/configurations'

export interface IEligibilityTaskState {
  tasks: IEligibilityTask[];
  selectedTask: IEligibilityTask | null;
  totalTasks: number;
  taskFilters: Record<string, any>;
}

export interface IEligibilityTaskStore extends IBaseStore {
  state: IEligibilityTaskState;
}

@Module({
  name: 'eligibilityTask',
  namespaced: true
})
export class EligibilityTaskModule extends VuexModule implements IEligibilityTaskState {
  tasks: IEligibilityTask[] = []
  selectedTask: IEligibilityTask | null = null
  totalTasks: number = 0
  taskFilters: Record<string, any> = {}

  @Mutation
  SET_TASKS (tasks: IEligibilityTask[]) {
    this.tasks = tasks
  }

  @Mutation
  SET_SELECTED_TASK (task: IEligibilityTask | null) {
    this.selectedTask = task
  }

  @Mutation
  SET_TOTAL_TASKS (total: number) {
    this.totalTasks = total
  }

  @Mutation
  SET_TASK_FILTERS (filters: Record<string, any>) {
    this.taskFilters = filters
  }

  @Action
  async getTasksByFilters (filters: IEligibilityTaskFiltersDTO) {
    const { tasks, total } = await Api.eligibilityTask.getTasksByFilters(filters)
    this.context.commit('SET_TASKS', tasks)
    this.context.commit('SET_TOTAL_TASKS', total)
  }

  @Action
  async updateTask (input: { taskId: number, data: Partial<IEligibilityTask> }) {
    await Api.eligibilityTask.updateTask(input.taskId, input.data)
  }

  @Action
  async assignUserToTask (input: { userId: number, taskId: number }) {
    await Api.eligibilityTask.assignUserToTask(input.userId, input.taskId)
  }

  @Action
  async submitPatientLiability (input: { taskId: number, data: IPatientLiability[], noPatientLiabilityData: boolean | null }) {
    return Api.eligibilityTask.submitPatientLiability(input.taskId, input.data, input.noPatientLiabilityData)
  }

  @Action
  async countPendingTasks () {
    return Api.eligibilityTask.countPendingTasks()
  }
}
